import { toast } from '@/utils/toast'

/**
 * Checks if an object is empty or undefined
 * @param {Object} dataObject - The object to check
 * @returns {boolean} True if the object is undefined or has no keys, false otherwise
 */
export function isEmptyObject(dataObject) {
    if (undefined === dataObject || Object.keys(dataObject).length === 0) {
        return true;
    }
    return false;
}



/**
 * Checks if an value is null or empty
 * @param {any} value - The value to check
 * @returns {boolean} True if the value is undefined, null, or an empty string, false otherwise
 */
export function isNullOrEmpty(value) {
    return value === undefined || value === null || value === '';
}

/**
 * Copies text to the clipboard, showing a toast on success/failure.
 * Non-string values (e.g. objects) are JSON-stringified to avoid "[object Object]" in the clipboard.
 * @param {any} value - The text or value to copy
 * @returns {Promise<boolean>} True if the copy succeeded, false otherwise
 */
export async function copyToClipboard(value) {
    if (!value) {
        toast.warning('No content to copy', 2000);
        return false;
    }
    const content = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
    try {
        await navigator.clipboard.writeText(content);
        toast.success('Copied to clipboard', 2000);
        return true;
    } catch (err) {
        toast.error('Failed to copy', 2000);
        return false;
    }
}